// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}
.home__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 12px var(--pad) calc(env(safe-area-inset-bottom, 0px) + 18px);
}

.home__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 2px 0 18px;
}
.home__logo {
  height: 64px;
  width: auto;
  object-fit: contain;
  transform: scaleX(-1);
  flex: 0 0 auto;
}
.home__brand-text {
  flex: 1;
  min-width: 0;
}
.home__word {
  font-size: 2rem;
  line-height: 1;
}
.home__defn {
  margin-top: 4px;
}
.home__defn-head {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 0.9rem;
}
.home__defn-head .pron {
  font-weight: 400;
  font-style: italic;
  color: var(--palette-text-muted);
}
.home__defn-head .pos {
  font-style: italic;
  color: var(--palette-primary);
}
.home__defn-body {
  display: block;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 0.88rem;
  line-height: 1.35;
  color: var(--palette-text-muted);
  margin-top: 2px;
}

.home__hero {
  margin-top: 6px;
  /*
   * .home__content is a flex column, so flex-shrink:0 keeps any hero card from
   * being squeezed below its content (which would spill the button out the
   * bottom). display:flex column lets the message + button sink to the card
   * bottom via margin-top:auto.
   */
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
/*
 * The three states that swap in place while the user is looking at the card --
 * loading ("missing puzzle"), not-ready ("try again later"), and today-unplayed
 * -- share one reserved height (the tallest of the three) so the button never
 * moves when one becomes another. The played card is excluded: it's only
 * reached via a screen transition, so pinning it to this height just adds
 * needless whitespace on the golden path.
 */
.home__hero--reserved {
  min-height: 253px;
}
.hero__date {
  font-size: 1.9rem;
  margin: 8px 0 14px;
}
.hero__clock {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--palette-text-muted);
  font-size: 0.92rem;
  margin-bottom: 18px;
  /* Pushes the clock line + button (+ score-so-far) to the card bottom. */
  margin-top: auto;
}
.hero__clock-icon {
  width: 18px;
  height: 18px;
  color: var(--palette-primary);
  flex: 0 0 18px;
}
.hero__clock b {
  color: var(--palette-text);
  font-weight: 700;
}
.hero__played {
  display: flex;
  justify-content: center;
  gap: 28px;
  margin: 12px 0 16px;
}
.hero__stat {
  text-align: center;
}
.hero__stat-val {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 2rem;
  line-height: 1;
  color: var(--palette-primary);
}
.hero__stat-lbl {
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
  margin-top: 5px;
}
.hero__pending {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: var(--palette-text-muted);
  font-size: 0.86rem;
  line-height: 1.35;
  margin-bottom: 18px;
  /* Pushes this text block (and the button that follows) to the card bottom,
     so the button sits at a fixed spot and the message rests just above it. */
  margin-top: auto;
}
.hero__pending b {
  color: var(--palette-text);
  font-weight: 700;
}
.hero__sofar {
  margin: 0 0 16px;
  color: var(--palette-text-muted);
  font-size: 0.86rem;
}
.hero__sofar b {
  color: var(--palette-text);
}

.hero__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--palette-text-muted);
  font-size: 0.92rem;
  /* Center the loader in the card's remaining space (below the date) both
     vertically and horizontally. margin:auto absorbs the leftover column space. */
  margin: auto;
}
.hero__dots {
  display: flex;
  gap: 6px;
  flex: 0 0 auto;
}
.hero__dots i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--palette-border-strong);
  opacity: 0.25;
  animation: heroDot 1.2s infinite;
}
.hero__dots i:nth-child(2) {
  animation-delay: 0.18s;
}
.hero__dots i:nth-child(3) {
  animation-delay: 0.36s;
}
@keyframes heroDot {
  0%,
  80%,
  100% {
    opacity: 0.22;
  }
  40% {
    opacity: 1;
    background: var(--palette-primary);
  }
}
@media (prefers-reduced-motion: reduce) {
  .hero__dots i {
    animation: none;
    opacity: 0.4;
  }
}

.recent {
  margin-top: 26px;
}
.recent__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 12px;
}
.recent__row {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: none;
}
.recent__row::-webkit-scrollbar {
  display: none;
}
.daycard {
  flex: 0 0 96px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  border-radius: 14px;
  padding: 14px 12px;
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: pointer;
}
.daycard__body {
  margin-top: 18px;
}
.daycard:disabled {
  cursor: default;
}
.daycard__day {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.15rem;
}
.daycard__date {
  font-size: 0.72rem;
  color: var(--palette-text-muted);
  margin-top: 1px;
}
.daycard__score {
  font-weight: 700;
  font-size: 1.05rem;
}
.daycard__score small {
  display: block;
  font-weight: 500;
  font-size: 0.66rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
}
.recent__gap {
  flex: 0 0 auto;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  color: var(--palette-text-muted);
  font-size: 1.5rem;
  line-height: 1;
  letter-spacing: 0.1em;
  user-select: none;
}
.daycard__words {
  margin-top: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--palette-text-muted);
}
.daycard__words small {
  display: block;
  font-weight: 500;
  font-size: 0.66rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
}

.home__foot {
  margin-top: auto;
  padding-top: 26px;
}
.linklist {
  display: flex;
  flex-direction: column;
}
.home__premium-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.home__premium-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}
.home__premium-notice {
  margin: 0 var(--pad) 16px;
  padding: 11px 12px;
  border: 1px solid var(--medal-gold);
  border-radius: 12px;
  background: #fffaf0;
  font-size: 0.82rem;
}
.home__premium-notice-message {
  display: block;
  line-height: 1.45;
}
.home__premium-notice-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 7px;
}
.home__premium-notice a {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  color: var(--palette-secondary);
  font-weight: 600;
  line-height: 1.3;
}
.home__premium-notice button {
  min-height: 40px;
  border: 0;
  padding: 6px 4px 6px 10px;
  color: var(--palette-secondary);
  background: transparent;
  font: 600 0.76rem var(--font-ui);
  cursor: pointer;
}
@media (max-width: 360px) {
  .home__premium-notice-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
  }
  .home__premium-notice button {
    align-self: flex-end;
  }
}
.linklist .listrow:last-of-type {
  border-bottom: 1px solid var(--palette-border);
}
.signed {
  text-align: center;
  margin-top: 18px;
  font-size: 0.78rem;
  color: var(--palette-text-muted);
}
.signed__out {
  color: inherit;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/screens/home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf;;;;;IAKE;EACF,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;;;;;;;EAOE;AACF;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,wEAAwE;EACxE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB;8EAC4E;EAC5E,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB;kFACgF;EAChF,YAAY;AACd;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;;;IAGE,aAAa;EACf;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".home {\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n}\n.home__content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 12px var(--pad) calc(env(safe-area-inset-bottom, 0px) + 18px);\n}\n\n.home__brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin: 2px 0 18px;\n}\n.home__logo {\n  height: 64px;\n  width: auto;\n  object-fit: contain;\n  transform: scaleX(-1);\n  flex: 0 0 auto;\n}\n.home__brand-text {\n  flex: 1;\n  min-width: 0;\n}\n.home__word {\n  font-size: 2rem;\n  line-height: 1;\n}\n.home__defn {\n  margin-top: 4px;\n}\n.home__defn-head {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n.home__defn-head .pron {\n  font-weight: 400;\n  font-style: italic;\n  color: var(--palette-text-muted);\n}\n.home__defn-head .pos {\n  font-style: italic;\n  color: var(--palette-primary);\n}\n.home__defn-body {\n  display: block;\n  font-family: var(--font-display);\n  font-style: italic;\n  font-size: 0.88rem;\n  line-height: 1.35;\n  color: var(--palette-text-muted);\n  margin-top: 2px;\n}\n\n.home__hero {\n  margin-top: 6px;\n  /*\n   * .home__content is a flex column, so flex-shrink:0 keeps any hero card from\n   * being squeezed below its content (which would spill the button out the\n   * bottom). display:flex column lets the message + button sink to the card\n   * bottom via margin-top:auto.\n   */\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n}\n/*\n * The three states that swap in place while the user is looking at the card --\n * loading (\"missing puzzle\"), not-ready (\"try again later\"), and today-unplayed\n * -- share one reserved height (the tallest of the three) so the button never\n * moves when one becomes another. The played card is excluded: it's only\n * reached via a screen transition, so pinning it to this height just adds\n * needless whitespace on the golden path.\n */\n.home__hero--reserved {\n  min-height: 253px;\n}\n.hero__date {\n  font-size: 1.9rem;\n  margin: 8px 0 14px;\n}\n.hero__clock {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--palette-text-muted);\n  font-size: 0.92rem;\n  margin-bottom: 18px;\n  /* Pushes the clock line + button (+ score-so-far) to the card bottom. */\n  margin-top: auto;\n}\n.hero__clock-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--palette-primary);\n  flex: 0 0 18px;\n}\n.hero__clock b {\n  color: var(--palette-text);\n  font-weight: 700;\n}\n.hero__played {\n  display: flex;\n  justify-content: center;\n  gap: 28px;\n  margin: 12px 0 16px;\n}\n.hero__stat {\n  text-align: center;\n}\n.hero__stat-val {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 2rem;\n  line-height: 1;\n  color: var(--palette-primary);\n}\n.hero__stat-lbl {\n  font-size: 0.72rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n  margin-top: 5px;\n}\n.hero__pending {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  color: var(--palette-text-muted);\n  font-size: 0.86rem;\n  line-height: 1.35;\n  margin-bottom: 18px;\n  /* Pushes this text block (and the button that follows) to the card bottom,\n     so the button sits at a fixed spot and the message rests just above it. */\n  margin-top: auto;\n}\n.hero__pending b {\n  color: var(--palette-text);\n  font-weight: 700;\n}\n.hero__sofar {\n  margin: 0 0 16px;\n  color: var(--palette-text-muted);\n  font-size: 0.86rem;\n}\n.hero__sofar b {\n  color: var(--palette-text);\n}\n\n.hero__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: var(--palette-text-muted);\n  font-size: 0.92rem;\n  /* Center the loader in the card's remaining space (below the date) both\n     vertically and horizontally. margin:auto absorbs the leftover column space. */\n  margin: auto;\n}\n.hero__dots {\n  display: flex;\n  gap: 6px;\n  flex: 0 0 auto;\n}\n.hero__dots i {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--palette-border-strong);\n  opacity: 0.25;\n  animation: heroDot 1.2s infinite;\n}\n.hero__dots i:nth-child(2) {\n  animation-delay: 0.18s;\n}\n.hero__dots i:nth-child(3) {\n  animation-delay: 0.36s;\n}\n@keyframes heroDot {\n  0%,\n  80%,\n  100% {\n    opacity: 0.22;\n  }\n  40% {\n    opacity: 1;\n    background: var(--palette-primary);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .hero__dots i {\n    animation: none;\n    opacity: 0.4;\n  }\n}\n\n.recent {\n  margin-top: 26px;\n}\n.recent__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.recent__row {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  scrollbar-width: none;\n}\n.recent__row::-webkit-scrollbar {\n  display: none;\n}\n.daycard {\n  flex: 0 0 96px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  border-radius: 14px;\n  padding: 14px 12px;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n}\n.daycard__body {\n  margin-top: 18px;\n}\n.daycard:disabled {\n  cursor: default;\n}\n.daycard__day {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.15rem;\n}\n.daycard__date {\n  font-size: 0.72rem;\n  color: var(--palette-text-muted);\n  margin-top: 1px;\n}\n.daycard__score {\n  font-weight: 700;\n  font-size: 1.05rem;\n}\n.daycard__score small {\n  display: block;\n  font-weight: 500;\n  font-size: 0.66rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n}\n.recent__gap {\n  flex: 0 0 auto;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  color: var(--palette-text-muted);\n  font-size: 1.5rem;\n  line-height: 1;\n  letter-spacing: 0.1em;\n  user-select: none;\n}\n.daycard__words {\n  margin-top: 6px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--palette-text-muted);\n}\n.daycard__words small {\n  display: block;\n  font-weight: 500;\n  font-size: 0.66rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n}\n\n.home__foot {\n  margin-top: auto;\n  padding-top: 26px;\n}\n.linklist {\n  display: flex;\n  flex-direction: column;\n}\n.home__premium-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.home__premium-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n}\n.home__premium-notice {\n  margin: 0 var(--pad) 16px;\n  padding: 11px 12px;\n  border: 1px solid var(--medal-gold);\n  border-radius: 12px;\n  background: #fffaf0;\n  font-size: 0.82rem;\n}\n.home__premium-notice-message {\n  display: block;\n  line-height: 1.45;\n}\n.home__premium-notice-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 7px;\n}\n.home__premium-notice a {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  color: var(--palette-secondary);\n  font-weight: 600;\n  line-height: 1.3;\n}\n.home__premium-notice button {\n  min-height: 40px;\n  border: 0;\n  padding: 6px 4px 6px 10px;\n  color: var(--palette-secondary);\n  background: transparent;\n  font: 600 0.76rem var(--font-ui);\n  cursor: pointer;\n}\n@media (max-width: 360px) {\n  .home__premium-notice-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 2px;\n  }\n  .home__premium-notice button {\n    align-self: flex-end;\n  }\n}\n.linklist .listrow:last-of-type {\n  border-bottom: 1px solid var(--palette-border);\n}\n.signed {\n  text-align: center;\n  margin-top: 18px;\n  font-size: 0.78rem;\n  color: var(--palette-text-muted);\n}\n.signed__out {\n  color: inherit;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
